<template>
  <div>
    <Alert class="success" icon="check">
      <p>
        An activation E-mail has been sent to your E-mail address.
      </p>
      <p>
        Please check your E-mail for further instructions.
      </p>
    </Alert>
    <Divider />
    <Alert class="info" icon="info">
      <p>
        <strong
          >If you can't find the E-mail in your Inbox, please check your spam
          folder.</strong
        >
      </p>
    </Alert>
  </div>
</template>

<script>
export default {
  name: "auth-register-success"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
